export default __webpack_public_path__ + "static/icon-16-3-b3ad8e1a2017913bfd0dd0a6cac0ce27.png";